import { EventBus } from "./EventBus";

// ---------- Combat ----------
export type CombatBusEvents = {
  damage: { src: number; tgt: number; amount: number; abilityId?: number; tick: number };
  heal: { src: number; tgt: number; amount: number; tick: number };
  death: { src?: number; tgt: number; tick: number };
  ability_cast_start: { src: number; abilityId: number; targetId?: number; durationS: number };
  ability_cast_end: { src: number; abilityId: number; targetId?: number };
  ability_cast_cancelled: { src: number; abilityId: number; reason: string };
  status_applied: { tgt: number; statusId: number; sourceId?: number; stacks: number };
  status_removed: { tgt: number; statusId: number };
};

// ---------- Network status ----------
export type NetworkBusEvents = {
  status_changed: { status: string; attempt?: number; error?: string };
  rtt_changed: { rttMs: number };
  zone_transferring: { newZone: number };
  zone_transferred: { newZone: number };
};

// ---------- World / time of day ----------
export type WorldBusEvents = {
  hour_changed: { hour: number; phase: string };
  weather_changed: { kind: string };
  region_entered: { name: string };
  region_exited: { name: string };
  spawn: { entityId: number };
  despawn: { entityId: number };
};

// ---------- UI ----------
export type UiBusEvents = {
  open_menu: { name: string };
  close_menu: { name: string };
  tooltip_show: { x: number; y: number; html: string };
  tooltip_hide: Record<string, never>;
  toast: { kind: "info" | "warn" | "error"; text: string };
  chat_message: { author: string; channel: string; text: string };
};

/**
 * One bus per domain — keeps event types tractable and lets you log/profile
 * each independently. Attach to `Game` or pass around explicitly.
 *
 *   const buses = createDomainBuses();
 *   buses.combat.on("damage", e => log(`${e.src} hit ${e.tgt} for ${e.amount}`));
 */
export interface DomainBuses {
  combat: EventBus<CombatBusEvents>;
  network: EventBus<NetworkBusEvents>;
  world: EventBus<WorldBusEvents>;
  ui: EventBus<UiBusEvents>;
}

export const createDomainBuses = (): DomainBuses => ({
  combat: new EventBus<CombatBusEvents>(),
  network: new EventBus<NetworkBusEvents>(),
  world: new EventBus<WorldBusEvents>(),
  ui: new EventBus<UiBusEvents>(),
});
